import { DOMAIN_CONFIGS } from '@/configs';
import { getCookie, getStorageKey, setCookie } from '../../../utils';

/**
 * 默认语言
 * 顺序: localStorage > navigator.language > en_US
 * 返回值统一处理为xx[_YY]
 * @returns
 */
export const getDefaultLanguage = () => {
  const navigator = window.navigator as any;
  // 优先获取浏览器语言 获取不到则取系统语言 默认英文
  let language: string =
    localStorage.getItem(getStorageKey('language')) ||
    navigator.language ||
    navigator.browserLanguage ||
    navigator.userLanguage ||
    navigator.systemLanguage ||
    DOMAIN_CONFIGS.SINOMOTIVE.defaults.language;

  if (language === 'en' || language === 'en_US') {
    language = 'en';
  } else if (language === 'zh' || language === 'zh_CN') {
    language = 'zh';
  } else if (language === 'ar') {
    language = 'ar';
  } else if (language?.toLowerCase() === 'ru' || language === 'ru_ru') {
    language = 'ru';
  } else {
    language = 'en';
  }

  // 如果localStorage中没有语言，则设置默认语言
  const lLanguage = localStorage.getItem(getStorageKey('language'));
  if (!lLanguage) {
    localStorage.setItem(getStorageKey('language'), language);
  }

  // 如果cookie中没有语言，则设置默认语言
  if (!getCookie('languageCode')) {
    setCookie('languageCode', language);
  }

  return language;
};
